import React from "react";

const SprintBadge = ({ sprint }) => (
  <div className={`text-xs py-1 px-2 rounded text-center font-bold`}>
    {sprint}
  </div>
);

export default SprintBadge;
